import { SHOW_MODAL, HIDE_MODAL } from "../../Constants";

export const showModal = ({ modalProps, template }) => dispatch => {
  dispatch({
    type: SHOW_MODAL,
    modalProps,
    template
  });
}

export const hideModal = () => dispatch => {
  dispatch({
    type: HIDE_MODAL
  });
}
